import React from 'react'

import clsx from 'clsx'
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'

import Grid from 'components/Grid'
import Rating from 'components/Rating'
import Review from 'components/Review'
import Typography from 'components/Typography'
import { useAppContext } from 'context/AppContext'
import { ROUTE_NAMES } from 'routes'

import MethodologyModal from './components/MethodologyModal'

import classes from './ValueForMoneySummaries.module.scss'

const SWIPER_BREAKPOINTS_CONFIG = {
  360: {
    slidesPerView: 1.2,
    centeredSlides: false,
    spaceBetween: 24,
  },
  600: {
    slidesPerView: 2.2,
    centeredSlides: false,
    spaceBetween: 24,
  },
  960: {
    slidesPerView: 3,
    spaceBetween: 24,
  },
}

/** @type {import("./types").default} */
const ValueForMoneySummaries = ({ className, listing, ...props }) => {
  const { route } = useAppContext()
  return (
    <Grid className={clsx('ValueForMoneySummaries', classes.root, className)} id="value-for-money-summary" {...props}>
      <div className={classes.content}>
        <Typography component="h2" variant="heading-md" className={classes.title}>
          User opinions about {listing.name} price and value
        </Typography>
        <div>
          <Typography className={classes.inline}>Value for money rating:</Typography>
          <Rating.Link
            isCompact
            hideTotals
            size="large"
            average={listing.reviews?.by_field?.rating_value}
            totals={listing.value_for_money_summary.num_review}
            className={classes.rating}
          />
        </div>
        <Typography>
          Of {listing.value_for_money_summary.num_review} reviews that provide robust commentary on {listing.name}
          &apos;s price and value, {listing.value_for_money_summary.positive_sentiment} mention it in a positive light.
        </Typography>
        {(listing.value_for_money_summary.summary || '').split('\n\n').map((paragraph, index) => (
          <Typography key={index}>{paragraph}</Typography>
        ))}
        <MethodologyModal dateRange={listing.value_for_money_summary.date_range} />
        {!!listing.value_for_money_summary?.snippets?.length && (
          <Typography>
            To see what individual users think of {listing.name}&apos;s cost and value, check out the review excerpts
            below.
          </Typography>
        )}
      </div>

      {!!listing.value_for_money_summary?.snippets?.length && (
        <>
          <Swiper
            modules={[Pagination]}
            pagination={{ clickable: true, el: '#cr-value-money-pagination' }}
            breakpoints={SWIPER_BREAKPOINTS_CONFIG}
          >
            {listing.value_for_money_summary.snippets.map((snippet, index) => (
              <SwiperSlide key={index}>
                <div className={classes.snippetContainer}>
                  <Review.Snippet
                    size="large"
                    type={snippet.type}
                    snippet={snippet}
                    className={classes.snippet}
                    engagementComponent={route === ROUTE_NAMES.PRICING ? 'user-opinions-pricing' : 'product_pricing'}
                  />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div id="cr-value-money-pagination" className={classes.pagination} />
        </>
      )}
    </Grid>
  )
}

export default ValueForMoneySummaries
